import { CJEvent } from 'types/event';

export function groupEventsByContiguity(events: CJEvent[]): CJEvent[][] {
  if (events.length === 0) {
    return [];
  }

  // Sort events by start time to ensure they're in order for grouping
  const sortedEvents = events
    .slice()
    .sort((a, b) => a.start.getTime() - b.start.getTime());

  return sortedEvents.reduce((acc: CJEvent[][], event: CJEvent) => {
    let addedToGroup = false;

    // Iterate through existing groups
    for (const group of acc) {
      const lastEvent = group[group.length - 1];

      // Check if event is contiguous with the last event in the current group
      if (lastEvent.end.getTime() === event.start.getTime()) {
        group.push(event);
        addedToGroup = true;
        break;
      }
    }

    // If the event wasn't added to any group, create a new group
    if (!addedToGroup) {
      acc.push([event]);
    }

    return acc;
  }, []);
}
